import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Radio,
  RadioGroup,
  Stack,
  Button,
  Flex,
  Badge,
  VStack,
  Divider,
  useToast,
  Textarea,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { TextAreaInput } from '@/components';
import { useUserStore } from '@/stores';
import { api2, fetchTrigger } from './hooks/protocol.hooks';

export const QuestionnaireModal = ({ isOpen, onClose, selectQuiz }: any) => {
  const toast = useToast({
    variant: 'solid',
    position: 'top-right',
    isClosable: true,
  });
  const user = useUserStore(state => state.user);
  const [value, setValue] = useState<any>(null);
  const [formStep, setFormStep] = useState(0);
  const [responseInput, setResponseInput] = useState('');
  const [indexQ, setIndexQ] = useState(0);
  const [quizData, setQuizData] = useState<any>(null);
  const [quiz, setQuiz] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [quizResponses, setQuizResponses] = useState<any>([]);
  const [quizResponsesArray, setQuizResponsesArray] = useState<any>([]);
  const [isFeedBack, setIsFeedBack] = useState<any>(false);
  const [feedBack, setFeedBack] = useState<any>(null);
  const [indexQuestion, setIndexQuestion] = useState(0);

  const alertColorBox = () => {
    switch (feedBack?.corAlerta ?? 99) {
      case 0:
        return 'green.400';
      case 1:
        return 'yellow.400';
      case 2:
        return 'red.400';
      default:
        return 'gray.400';
    }
  };

  const getQuizData = async (pId?: undefined) => {
    if (!pId) {
      setIndexQ(0);
      setIndexQuestion(0);
      setQuiz([]);
      setQuizResponses([]);
    }
    setLoading(true);
    try {
      const data = await fetchTrigger(
        selectQuiz?.publicacaoId,
        selectQuiz?.protocoloId,
      );

      if (!data?.perguntas) {
        toast({
          title: data || 'Ocorreu um erro!',
          status: 'error',
        });
        // navigation.navigate('HistoryOrientations');
        return;
      }
      setQuizData({
        publicacaoId: data.publicacaoId,
        questionarioId: data.questionarioId,
        encadeamentoId: data.encadeamentoId,
        qtInicial: data.qtInicial,
        qtfinal: data.qtFinal,
        textoOrientacao: data.textoOrientacao,
        textoFinal: data.textoFinal,
      });
      setQuiz(data?.perguntas);
    } catch (error) {
      setQuiz([]);
    } finally {
      setLoading(false);
    }
  };

  const updateResponseOnQuiz = (
    questionId: any,
    questionType: number,
    response: any,
  ) => {
    const newResponseFormatted: any = {
      perguntaId: questionId,
      textoLivre: '',
      alternativaIds: [],
    };

    if ([3, 4, 5].includes(questionType)) {
      newResponseFormatted.textoLivre = response;
    }
    if ([1, 2, 6].includes(questionType)) {
      newResponseFormatted.alternativaIds = [response];
    }

    if (
      newResponseFormatted.textoLivre === '' &&
      newResponseFormatted?.alternativaIds?.length === 0
    ) {
      return;
    }

    setQuizResponses([newResponseFormatted]);
    setQuizResponsesArray([
      ...quizResponsesArray.filter(
        (q: { perguntaId: string }) => q.perguntaId !== questionId,
      ),
      newResponseFormatted,
    ]);
  };

  const onSubmit = async (questionarioId: any) => {
    const payload = {
      publicacaoId: selectQuiz?.publicacaoId,
      questionarioId,
      userId: user?.id,
      encadeamentoId: quizData.encadeamentoId,
      qtInicial: quizData.qtInicial,
      qtfinal: quizData.qtfinal,
      respostas: quizResponsesArray,
    };

    try {
      setLoading(true);
      const { data } = await api2.post(
        '/app/publicacao/responder-publicacao',
        payload,
      );

      setFeedBack(data?.conclusao);
      if (data?.conclusao) setIsFeedBack(true);
      setIndexQuestion(indexQuestion + 1);
      setIndexQ(indexQ + 1);
      setQuizResponses([]);
      setQuizResponsesArray([]);
      setResponseInput('');
    } catch (err) {
      let message;
      if (axios.isAxiosError(err)) {
        message =
          err?.response?.data?.error?.message ||
          'Erro inesperado ao enviar as respostas.';
      }

      toast({
        title: message || 'Erro inesperado ao enviar as respostas.',
        status: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const ValidPayload = () => {
    if (quiz[indexQ + 1] && quiz[indexQ + 1]?.isMarcadorFimQuestionario) {
      onSubmit(quiz[indexQ + 1]?.questionarioId);
      return;
    }
    if (!quiz[indexQ + 1]) {
      setFormStep(3);
      return;
    }
    setIndexQuestion(indexQuestion + 1);
    setIndexQ(indexQ + 1);
    setQuizResponses([]);
    setResponseInput('');
  };

  const resetState = () => {
    setFormStep(0);
    setIndexQuestion(0);
    setIndexQ(0);
    setQuizResponses([]);
    setQuizResponsesArray([]);
    setResponseInput('');
    setValue(null);
    setFeedBack(null);
    setIsFeedBack(false);
    onClose();
  };

  useEffect(() => {
    setFormStep(0);
    getQuizData();
  }, [selectQuiz]);

  return (
    <Modal isOpen={isOpen} onClose={resetState} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />

        <ModalBody p={6}>
          {formStep === 0 ? (
            <>
              <VStack spacing={4} textAlign="center" py={6}>
                <Text fontSize="2xl" fontWeight="bold">
                  Olá, {user?.name}!!
                </Text>
                <Text fontSize="xl" fontWeight="bold">
                  Que bom te ver!
                </Text>

                <Text fontSize="sm" color="gray.600">
                  Vamos para o {'\n'} questionário de hoje?
                </Text>

                <Text fontSize="md" color="gray.600">
                  Começaremos pelo <b>{selectQuiz?.descricao}</b>
                </Text>
              </VStack>

              <Divider mt={4} />
              <Flex justify="flex-end" mt={6}>
                <Button
                  ml={5}
                  colorScheme="blue"
                  isLoading={loading || !quiz || quiz.length <= 0}
                  disabled={!quiz || quiz.length <= 0}
                  onClick={() => {
                    setFormStep(1);
                    setIndexQuestion(0);
                    setIndexQ(0);
                    setQuizResponses([]);
                    setQuizResponsesArray([]);
                    setResponseInput('');
                  }}
                >
                  Vamos!
                </Button>
              </Flex>
            </>
          ) : formStep === 1 ? (
            quiz?.length > 0 &&
            [quiz[indexQ]]?.map((q: any) => {
              const min = q.minAlternativas > 0 ? q.minAlternativas : 1;
              const max = q.maxAlternativas > 0 ? q.maxAlternativas : 1;
              const validated = [1, 2, 6].includes(q.tipoPergunta)
                ? quizResponses[0]?.alternativaIds?.length < min ||
                  quizResponses[0]?.alternativaIds?.length > max
                : !quizResponses[0]?.textoLivre ||
                  quizResponses[0]?.textoLivre === '';
              const disabledButton = !(
                quizResponsesArray.length > 0 &&
                quizResponsesArray[quizResponsesArray.length - 1].perguntaId ===
                  q.questionarioPerguntaid
              );
              if (isFeedBack)
                return (
                  <>
                    <Text fontSize="lg" fontWeight="bold" mb={4}>
                      Resultado (Rótulo): {feedBack.rotulo || ''}
                    </Text>

                    <Text>
                      Status:{' '}
                      <Badge
                        bg={alertColorBox() as any}
                        top="-3"
                        right="-1.5"
                        fontFamily="Rubik"
                        color="#fff"
                        p="2"
                        fontSize="12"
                        borderRadius={50}
                      />
                    </Text>
                    <Text mt={2}>Score: {feedBack.score || '0'}</Text>

                    {/* {feedBack.indicadorProfissional && (
                      <Box mt={4} fontSize="md" color="gray.600">
                        {feedBack.indicadorProfissional || '-'}
                      </Box>
                    )} */}
                    <Box mt={4} fontSize="md" color="gray.600">
                      FeedBack: {feedBack.feedBack || '-'}
                    </Box>

                    <Flex justify="flex-end" mt={6}>
                      <Button
                        colorScheme="blue"
                        onClick={() => {
                          setFeedBack(null);
                          setIsFeedBack(false);
                        }}
                      >
                        Próximo
                      </Button>
                    </Flex>
                  </>
                );

              if (q.isMarcadorFimQuestionario)
                return (
                  <>
                    <VStack spacing={4} textAlign="center" py={6}>
                      <Text fontSize="sm" color="gray.600">
                        {q.textoOrientacao || 'TEXTO DE TRANSIÇÃO'}
                      </Text>
                    </VStack>
                    <Divider mt={4} />
                    <Flex justify="flex-end" mt={6}>
                      <Button
                        ml={5}
                        colorScheme="blue"
                        isLoading={loading}
                        disabled={loading}
                        onClick={ValidPayload}
                      >
                        {quiz?.length === indexQ + 1 ? 'ENVIAR' : 'CONTINUAR'}
                      </Button>
                    </Flex>
                  </>
                );
              return (
                <>
                  <Text fontWeight="bold" mb={4}>
                    {q.enunciado}
                  </Text>

                  {[1, 2, 6].includes(q.tipoPergunta) && (
                    <RadioGroup
                      isDisabled={loading}
                      value={value}
                      onChange={selectedId => {
                        setValue(selectedId);
                        updateResponseOnQuiz(
                          q.questionarioPerguntaid,
                          q.tipoPergunta,
                          selectedId,
                        );
                      }}
                    >
                      <Stack>
                        {q?.alternativas.map((opcao: any) => (
                          <Box
                            key={opcao.id}
                            p={3}
                            border="1px solid #E2E8F0"
                            borderRadius="md"
                            cursor="pointer"
                            _hover={{ bg: 'gray.50' }}
                            _checked={{ borderColor: 'blue.500' }}
                            onClick={() => {
                              if (loading) return;
                              const selectedId = opcao.id.toString();
                              setValue(selectedId);
                              updateResponseOnQuiz(
                                q.questionarioPerguntaid,
                                q.tipoPergunta,
                                selectedId,
                              );
                            }}
                          >
                            <Radio
                              value={opcao.id.toString()}
                              isDisabled={loading}
                            >
                              {opcao.descricao}
                            </Radio>
                          </Box>
                        ))}
                      </Stack>
                    </RadioGroup>
                  )}

                  {[3].includes(q.tipoPergunta) && (
                    <TextAreaInput
                      placeholder="Insira sua resposta"
                      label=""
                      value={responseInput}
                      onChange={(text: any) => {
                        setResponseInput(text.target.value);
                        updateResponseOnQuiz(
                          q.questionarioPerguntaid,
                          q.tipoPergunta,
                          text.target.value,
                        );
                      }}
                    />
                  )}

                  {[4].includes(q.tipoPergunta) && (
                    <Textarea
                      inputMode="numeric"
                      placeholder="Insira sua resposta"
                      value={responseInput}
                      onChange={(text: any) => {
                        setResponseInput(text.target.value);
                        updateResponseOnQuiz(
                          q.questionarioPerguntaid,
                          q.tipoPergunta,
                          value,
                        );
                      }}
                    />
                  )}

                  {[5].includes(q.tipoPergunta) && (
                    <TextAreaInput
                      placeholder="Insira sua resposta"
                      label=""
                      value={responseInput}
                      onChange={(text: any) => {
                        setResponseInput(text);
                        updateResponseOnQuiz(
                          q.questionarioPerguntaid,
                          q.tipoPergunta,
                          value,
                        );
                      }}
                    />
                  )}

                  <Flex justify="flex-end" mt={6}>
                    <Button
                      colorScheme="blue"
                      onClick={ValidPayload}
                      isLoading={loading}
                      disabled={validated || disabledButton || loading}
                    >
                      {quiz?.length === indexQ + 1 ? 'ENVIAR' : 'Próximo →'}
                    </Button>
                  </Flex>
                </>
              );
            })
          ) : (
            <>
              <VStack spacing={4} textAlign="center" py={6}>
                <Text fontSize="2xl" fontWeight="bold">
                  Questionário Concluído!
                </Text>

                <Text fontSize="sm" color="gray.600">
                  Obrigado por responder ao questionário. Suas respostas foram
                  registradas com sucesso.
                </Text>

                <Text fontSize="sm" color="gray.600">
                  O profissional de saúde responsável receberá suas informações
                  e entrará em contato se necessário.
                </Text>
              </VStack>

              <Divider mt={4} />
              <Flex justify="flex-end" mt={6}>
                <Button
                  variant="outline"
                  colorScheme="blue"
                  onClick={resetState}
                >
                  Histórico de Acompanhamento
                </Button>

                <Button ml={5} colorScheme="blue" onClick={resetState}>
                  Fechar
                </Button>
              </Flex>
            </>
          )}
          {/* {feedback === 1 ? (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Resultado (Rótulo): Estado de Saúde
              </Text>

              <Text>
                Status:{' '}
                <Badge
                  bg="red"
                  top="-3"
                  right="-1.5"
                  fontFamily="Rubik"
                  color="#fff"
                  px="2"
                  py="1.5"
                  fontSize="12"
                  borderRadius={50}
                />
              </Text>
              <Text mt={2}>Score: 4</Text>

              <Box mt={4} fontSize="sm" color="gray.600">
                FeedBack: Sua percepção de saúde nesta semana está boa. Mantenha
                o pré-natal e observe mudanças importantes. (classificação de
                sinal, não é diagnóstico)
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button
                  colorScheme="blue"
                  onClick={() => {
                    setFeedback(0);
                    setFinal(1);
                  }}
                >
                  Próximo
                </Button>
              </Flex>
            </>
          ) : final === 1 ? (
            <>
              <Text
                fontSize="lg"
                fontWeight="bold"
                mt={10}
                mb={4}
                textAlign="center"
              >
                Obrigado por suas respostas!
              </Text>

              <Box mt={4} fontSize="sm" color="gray.600" w="100%">
                {' '}
                <Text>
                  Você concluiu o primeiro questionário. Agora vamos iniciar o
                  questionário 2 com novas perguntas sobre seu bem-estar.
                </Text>
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button colorScheme="blue" onClick={() => setFinal(0)}>
                  Próximo
                </Button>
              </Flex>
            </>
          ) : feedback === 2 ? (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Resultado (Rótulo): Estado de Saúde
              </Text>

              <Text>
                Status:{' '}
                <Badge
                  bg="green"
                  top="-3"
                  right="-1.5"
                  fontFamily="Rubik"
                  color="#fff"
                  px="2"
                  py="1.5"
                  fontSize="12"
                  borderRadius={50}
                />
              </Text>
              <Text mt={2}>Score: 17</Text>

              <Box mt={4} fontSize="sm" color="gray.600">
                FeedBack: Sua percepção de saúde nesta semana está boa. Mantenha
                o pré-natal e observe mudanças importantes. (classificação de
                sinal, não é diagnóstico)
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button
                  colorScheme="blue"
                  onClick={() => {
                    setFeedback(0);
                    setFinal(2);
                  }}
                >
                  Próximo
                </Button>
              </Flex>
            </>
          ) : final === 2 ? (
            <>
              <Text
                fontSize="lg"
                fontWeight="bold"
                mt={10}
                mb={4}
                textAlign="center"
              >
                Ótimo progresso!
              </Text>

              <Box mt={4} fontSize="sm" color="gray.600" w="100%">
                {' '}
                <Text>
                  Você finalizou o segundo questionário. Vamos agora para o
                  último questionário, com apenas 2 perguntas finais.
                </Text>
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button colorScheme="blue" onClick={() => setFinal(0)}>
                  Próximo
                </Button>
              </Flex>
            </>
          ) : feedback === 3 ? (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Resultado (Rótulo): Estado de Saúde
              </Text>

              <Text>
                Status:{' '}
                <Badge
                  bg="yellow"
                  top="-3"
                  right="-1.5"
                  fontFamily="Rubik"
                  color="#fff"
                  px="2"
                  py="1.5"
                  fontSize="12"
                  borderRadius={50}
                />
              </Text>
              <Text mt={2}>Score: 12</Text>

              <Box mt={4} fontSize="sm" color="gray.600">
                FeedBack: Sua percepção de saúde nesta semana está boa. Mantenha
                o pré-natal e observe mudanças importantes. (classificação de
                sinal, não é diagnóstico)
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button
                  colorScheme="blue"
                  onClick={() => {
                    setFeedback(0);
                    setFinal(0);
                    setIsLast(true);
                  }}
                >
                  Próximo
                </Button>
              </Flex>
            </>
          ) : !isLast ? (
            <>
              <Text fontWeight="bold" mb={4}>
                {questions[step].pergunta}
              </Text>

              <RadioGroup value={value} onChange={setValue}>
                <Stack>
                  {questions[step].opcoes.map((opcao, i) => (
                    <Box p={3} border="1px solid #E2E8F0" borderRadius="md">
                      <Radio value={opcao}>{opcao}</Radio>
                    </Box>
                  ))}
                </Stack>
              </RadioGroup>

              <Flex justify="flex-end" mt={6}>
                <Button
                  colorScheme="blue"
                  onClick={handleNext}
                  isDisabled={!value}
                >
                  Próximo →
                </Button>
              </Flex>
            </>
          ) : (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Finalização
              </Text>

              <VStack spacing={4} textAlign="center" py={6}>
                <Text fontSize="2xl" fontWeight="bold">
                  Questionário Concluído!
                </Text>

                <Text fontSize="sm" color="gray.600">
                  Obrigado por responder ao questionário. Suas respostas foram
                  registradas com sucesso.
                </Text>

                <Text fontSize="sm" color="gray.600">
                  O profissional de saúde responsável receberá suas informações
                  e entrará em contato se necessário.
                </Text>
              </VStack>

              <Divider mt={4} />
              <Flex justify="flex-end" mt={6}>
                <Button
                  variant="outline"
                  colorScheme="blue"
                  onClick={resetState}
                >
                  Histórico de Acompanhamento
                </Button>

                <Button ml={5} colorScheme="blue" onClick={resetState}>
                  Fechar
                </Button>
              </Flex>
            </>
          )} */}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
